export default __webpack_public_path__ + "static/media/tsullogo.d70784a1.svg";